import React from 'react';

export default function TitleValue(props) {

    const titles = props.title ? props.title.split("\n") : ""

    let className = "horizontalScreen "
    if (props.className) {
        className = className + props.className
    }
    if (props.onClick) {
        className = className + ' clickable'
    }

    return (<div onClick={props.onClick} className={className}>
        <div className={props.titleClassName ? props.titleClassName + " marginRightSmall" :
            "mediumText marginRightSmall singleLine"}>
            {titles.map((title, index) => {
                if (title === "\n" || title === "\r")
                    return (<br key={index}/>)
                else
                    return (<div key={index}>{title}</div>)
            })}
        </div>
        {
            props.showMobile ?(props.value && props.onClick) ?
                <div className={props.valueClassName ?
                    props.valueClassName + " marginLeftRightSmall singleLine blueColor" :
                    "mediumTextBold marginRightSmall singleLine blueColor"}>
                    {props.value}
                </div> :
                <div className="flex-column gap-2-5">
                    <div className={props.valueClassName ?
                        props.valueClassName + " marginLeftRightSmall singleLine" :
                        "mediumTextBold marginRightSmall singleLine"}>
                        {props.value}
                    </div>
                    {props.secondValue &&
                        <div className={props.secondValueClassName ?
                            props.secondValueClassName + " marginLeftRightSmall singleLine" :
                            "mediumTextBold marginRightSmall singleLine"}>
                            {props.secondValue}
                        </div>
                    }
                </div> : (props.value && props.onClick) ?
                    <div className={props.valueClassName ?
                        props.valueClassName + " marginLeftRightSmall singleLine blueColor" :
                        "mediumTextBold marginRightSmall singleLine blueColor"}>
                        {props.value}
                    </div> :
                <span style={{display:'flex'}}>
                    <div className={props.valueClassName ?
                        props.valueClassName + " marginLeftRightSmall singleLine" :
                        "mediumTextBold marginRightSmall singleLine"}>
                        {props.value}
                    </div>
                    {props.secondValue &&
                        <div className={props.secondValueClassName ?
                            props.secondValueClassName + " marginLeftRightSmall singleLine" :
                            "mediumTextBold marginRightSmall singleLine"}>
                            {props.secondValue}
                        </div>
                    }
                </span>

        }


    </div>)
}